import React, { useState, useEffect } from 'react';

const ChatWithAIPage = () => {
  const [messages, setMessages] = useState([
    { id: 1, sender: 'ai', text: 'Hello! I\'m here to tell you anything you want to know about Max Gaspers Scott. Feel free to ask about his experience, views on work or life philosophy' }
  ]);
  const [inputValue, setInputValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [sessionId, setSessionId] = useState(null);

  // Generate a unique session ID on component mount
  useEffect(() => {
    // Check if we already have a session ID in localStorage
    const storedSessionId = localStorage.getItem('chat_session_id');
    if (storedSessionId) {
      setSessionId(storedSessionId);
    } else {
      // Generate a new session ID
      const newSessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      localStorage.setItem('chat_session_id', newSessionId);
      setSessionId(newSessionId);
    }
  }, []);

  const handleSendMessage = async () => {
    if (inputValue.trim() === '' || isLoading || !sessionId) return;

    // Add user message
    const newUserMessage = {
      id: Date.now(),
      sender: 'user',
      text: inputValue
    };

    setMessages(prev => [...prev, newUserMessage]);
    setInputValue('');
    setIsLoading(true);

    try {
      // Call the Rust backend endpoint which proxies to FastAPI
      const response = await fetch('/api/chat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          message: inputValue,
          session_id: sessionId
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      const newAiMessage = {
        id: Date.now() + 1,
        sender: 'ai',
        text: data.response || 'Sorry, I couldn\'t generate a response.'
      };

      setMessages(prev => [...prev, newAiMessage]);
    } catch (error) {
      console.error('Error sending message:', error);

      const errorMessage = {
        id: Date.now() + 1,
        sender: 'ai',
        text: 'Sorry, I encountered an error. Please try again.'
      };

      setMessages(prev => [...prev, errorMessage]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !isLoading) {
      handleSendMessage();
    }
  };

  // Clear chat history function
  const handleClearChat = () => {
    if (window.confirm('Are you sure you want to clear the chat history?')) {
      setMessages([
        { id: 1, sender: 'ai', text: 'Hello! I\'m your AI assistant. How can I help you today?' }
      ]);

      // Generate a new session ID to start fresh
      const newSessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      localStorage.setItem('chat_session_id', newSessionId);
      setSessionId(newSessionId);
    }
  };

  return (
    <div className="page-shell">
      <div className="page-shell__content">
        <section className="panel panel--padded chat-layout">
          <div className="chat-header">
            <div>
              <div className="eyebrow">Interactive assistant</div>
              <h1 className="section-title" style={{ marginBottom: '0.35rem' }}>Chat with AI</h1>
              <p className="page-copy" style={{ marginBottom: 0 }}>
                Ask about Max Gaspers Scott&apos;s experience, work style, or project background.
              </p>
            </div>

            <button type="button" className="danger-button" onClick={handleClearChat}>
              Clear chat
            </button>
          </div>

          <div className="chat-log">
            {messages.map((message) => (
              <div
                key={message.id}
                className={`chat-bubble ${message.sender === 'user' ? 'chat-bubble--user' : 'chat-bubble--ai'}`}
              >
                {message.text}
              </div>
            ))}
          </div>

          <div className="chat-composer">
            <input
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Type your message here..."
              disabled={isLoading || !sessionId}
              className="chat-input"
            />
            <button
              type="button"
              onClick={handleSendMessage}
              disabled={isLoading || !sessionId}
              className="chat-send"
            >
              {isLoading ? 'Sending...' : 'Send'}
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ChatWithAIPage;
